import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export function useIssues() {
    return useQuery({
        queryKey: ["issues"],
        queryFn: async () => (await api.get("/issues")).data,
        staleTime: 30000,
    });
}
